import React from 'react';
import { InputNumber, Row, Col, Typography } from 'antd';
import { formatPrice } from '../../utils/currencyUtils';

const { Text } = Typography;

const ItemPricing = ({
  item,
  proposalCurrency,
  onItemChange,
  onItemBlur,
  index,
}) => {
  const finalPrice = item.final_price ?? item.list_price ?? 0;

  return (
    <Row gutter={[12, 12]} align="bottom">
      <Col xs={8} sm={5} md={4}>
        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>
          Qty
        </Text>
        <div data-testid={`item-quantity-${index}`}>
          <InputNumber
            step={1}
            style={{ width: '100%' }}
            value={
              item.quantity === '' || item.quantity == null
                ? null
                : Number(item.quantity)
            }
            onChange={(value) => onItemChange(index, 'quantity', value ?? 1)}
            onBlur={() => onItemBlur(index, 'quantity', item.quantity)}
          />
        </div>
      </Col>
      <Col xs={16} sm={8} md={7}>
        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>
          List price
        </Text>
        <div data-testid={`item-price-${index}`}>
          <InputNumber
            min={0}
            step={0.01}
            style={{ width: '100%' }}
            value={
              item.list_price === '' || item.list_price == null
                ? null
                : Number(item.list_price)
            }
            addonAfter={proposalCurrency}
            onChange={(value) => onItemChange(index, 'list_price', value ?? 0)}
            onBlur={() => onItemBlur(index, 'list_price', item.list_price)}
          />
        </div>
      </Col>
      <Col xs={12} sm={6} md={6}>
        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>
          Discount
        </Text>
        <InputNumber
          min={0}
          max={100}
          step={0.01}
          style={{ width: '100%' }}
          value={
            item.discount === '' || item.discount == null
              ? null
              : Number(item.discount)
          }
          addonAfter="%"
          onChange={(value) => onItemChange(index, 'discount', value ?? 0)}
          onBlur={() => onItemBlur(index, 'discount', item.discount)}
        />
      </Col>
      <Col xs={12} sm={5} md={7}>
        <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>
          Final
        </Text>
        <Text strong style={{ fontSize: 16, lineHeight: '32px', display: 'block' }}>
          {formatPrice(finalPrice, proposalCurrency)}
        </Text>
      </Col>
    </Row>
  );
};

export default ItemPricing;
